export const constants = {
  subjectTitles: [
    {
      title: 'Record',
      className: 'small'
    },
    {
      title: 'Change Date',
      className: 'small'
    },
    {
      title: 'Subject Change',
      className: 'wide'
    }
  ],
  data: [
    {
      record: 'Pensylvania 2011-2012 HB 1910',
      changeDate: '10/4/2011',
      subjectChange: [
        'added claims settlement practices - p',
        'added claims settlement practices - l',
        'deleted liens/medicare - p'
      ]
    },
    {
      record: 'Pensylvania 2011-2012 HB 1910',
      changeDate: '10/4/2011',
      subjectChange: [
        'added producer issues - p'
      ]
    },
    {
      record: 'Pensylvania 2011-2012 HB 1910',
      changeDate: '10/4/2011',
      subjectChange: [
        'added producer issues - p'
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/ManagementSubjectChanges/constants.js